import { isPlatformBrowser } from '@angular/common';

import { SafeStorageService } from '@service/safe-storage.service';

export const OnlyBrowser = (): ClassDecorator => {
  return (constructor: any) => {
    const originalMethods = Object.getOwnPropertyNames(constructor.prototype);
    originalMethods.forEach(methodName => {
      const originalMethod = constructor.prototype[methodName];
      // 為了讓 this 可以正確傳遞，使用 function，而不是 () =>.
      constructor.prototype[methodName] = function (...args: any[]): any {
        if (isPlatformBrowser(SafeStorageService.PLATFORM_ID)) {
          return originalMethod.apply(this, args);
        } else {
          // skip method
        }
      };
    });
  };
};
